<svg
  width="12"
  height="12"
  viewBox="0 0 12 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M10.5 6.375H6M6 6.375H1.5M6 6.375L6.0011 7.625M4.0011 3.875V1.875H8.0011V3.875M10.625 10.125H1.375V3.875H10.625V10.125Z"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="square"
  />
</svg>
